import {useDispatch} from 'react-redux';

import {exportActions} from '../../../../../actions/fortnite-game';

export interface UseTrackExportErrors {
    trackPDFError: (error: Error) => void;
    trackCSVError: (error: Error) => void;
}

const useTrackExportErrors = (): UseTrackExportErrors => {
    const dispatch = useDispatch();

    const trackPDFError = (error: Error) => {
        dispatch(exportActions.PDFExportError(error));
    };
    const trackCSVError = (error: Error) => {
        dispatch(exportActions.CSVExportError(error));
    };

    return {
        trackPDFError,
        trackCSVError
    };
};

export default useTrackExportErrors;
